import { installCursorBrowserHydrationGuard } from "./lib/cursor-browser-hydration";

/**
 * Cursor's in-editor browser stamps `data-cursor-ref` onto DOM nodes before
 * React hydrates. That is not an app mismatch; strip those attributes first.
 */
installCursorBrowserHydrationGuard();
